import classes from "./Aside.module.scss";
import { useEffect, useState, useContext } from "react";
import cart from "./../../../../../assets/images/cart.svg";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import arrowLeft from "./../../../../../assets/images/arrow_left.svg";
import triangleWarning from "./../../../../../assets/images/triangle_warning.svg";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import CardBase from "../../../../UI/Card/CardBase/CardBase";
import SystemContext from "../../../../../context/SystemContext";
import checkPayment from "../../../../../assets/images/check_payment.svg";

const Aside = ({ BuyPlan, UpdateUserInfo, Products, PaymentMethod, instantPay }) => {
  const payload = useSelector((state) => state.purchase);
  const { CheckError, setCheckError, setOpenModalWaitPayment, errorRule, setErrorRule, changePropertyUrl } =
    useContext(SystemContext);

  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [ButtonsArea, setButtonsArea] = useState({
    Top: {
      content: "",
      step: "",
      show: true,
      checked: true,
      func: false,
      name: "",
    },
    Back: {
      content: "",
      step: "",
      show: true,
    },
  });
  // const [PlanName, setPlanName] = useState();
  const [Periodicity, setPeriodicity] = useState();
  const [isLoadingUserInfo, setIsLoadingUserInfo] = useState(false);

  useEffect(() => {
    switch (payload.purchase.step) {
      case "InvoiceData":
        setButtonsArea((prevState) => ({
          ...prevState,
          Top: {
            content: "PaymentArea",
            step: PaymentMethod && PaymentMethod == "pix" ? "DescPix" : "CreditCard",
            show: true,
            checked: CheckError.invoiceData,
            func: false,
            funcCall: async () => {
              return new Promise((resolve, reject) => {
                UpdateUserInfo(resolve, reject);
              });
            },
            name: t("purchase.continue"),
          },
          Back: {
            content: payload.planInfo.content,
            step: payload.planInfo.step,
            show: true,
            funcCall: async (content="") => {
              changePropertyUrl((content)?-1:0)
            }
          },
        }));
        break;
      case "CreditCard":
        setButtonsArea((prevState) => ({
          ...prevState,
          Top: {
            content: "ChoosePlan",
            step: "OpenSpinner",
            show: true,
            checked: errorRule?.checkbox,
            func: true,
            name: (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  fontWeight: "bold",
                  gap: "15px",
                }}
              >
                <div>finalizar</div>
                <img
                  style={{ width: "16px" }}
                  src={checkPayment}
                  alt={t("purchase.left_arrow")}
                />
              </div>
            ),
          },
          Back: {
            content: "PaymentArea",
            step: "InvoiceData",
            show: true,
          },
        }));
        break;
      case "PaymentError":
        setButtonsArea((prevState) => ({
          ...prevState,
          Top: {
            show: false,
            checked: true,
            func: false,
          },
          Back: {
            show: false,
          },
        }));
        break;
      case "DescPix":
        setButtonsArea((prevState) => ({
          ...prevState,
          Top: {
            content: "ChoosePlan",
            step: "OpenSpinner",
            show: true,
            checked: CheckError.pix,
            func: true,
            name: (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                  fontWeight: "bold",
                  gap: "15px",
                }}
              >
                <div>{t("purchase.finish")}</div>
                <img
                  style={{ width: "16px" }}
                  src={checkPayment}
                  alt={t("purchase.left_arrow")}
                />
              </div>
            ),
          },
          Back: {
            content: "PaymentArea",
            step: "InvoiceData",
            show: true,
          },
        }));
        break;
      case "PixQrCode":
        setButtonsArea((prevState) => ({
          ...prevState,
          Top: {
            content: "PurchaseSuccess",
            step: "PurchaseSuccess",
            show: true,
            checked: payload.planInfo.pixIsPaid,
            func: false,
            name: t("purchase.i_already_made_my_payment"),
          },
          Back: {
            content: "PaymentArea",
            step: "DescPix",
            show: true,
          },
        }));
        break;
      default:
        break;
    }
  }, [payload, CheckError]);
  /* useEffect(() => {
    console.log(payload)
  },[payload]); */

  // useEffect(() => {
  //   const getNameById = (id_product) => {
  //     const foundItem = Products?.periodicity.find(
  //       (item) => item.id_product === id_product
  //     );
  //     return foundItem ? foundItem.name : null;
  //   };
  //   const getDescByName = (name_product) => {
  //     const foundItem = Products?.periodicity.find(
  //       (item) => item.name === name_product
  //     );
  //     return foundItem ? foundItem.description.product_descriptions : null;
  //   };
  //   const name = getNameById(payload.PostData.product_id[0]);
  //   setPlanName(name);
  //   const description = getDescByName(name);

  //   dispatch({
  //     type: "PURCHASE",
  //     planInfo: {
  //       planName: name,
  //       planDescription: description,
  //     },
  //   });
  // }, [Products]);

  useEffect(() => {
    switch (payload.PostData.periodicity) {
      case "monthly":
        setPeriodicity(t("purchase.monthly"));
        break;
      case "annual":
        setPeriodicity(t("purchase.annual"));
        break;
      case "lifetime":
        setPeriodicity("");
        break;
      default:
        break;
    }
  }, [payload]);

  const TopButton = async () => {
    setIsLoadingUserInfo(true);
    if (ButtonsArea.Top.hasOwnProperty("funcCall") && ButtonsArea.Top.funcCall) {
      try{
        await ButtonsArea.Top.funcCall();
      }catch(e){
        console.log("Error occurred while calling Top button function:", e);
        setIsLoadingUserInfo(false);
        return
      }
    }
    ButtonsArea.Top.checked ?
      dispatch({
        type: "PURCHASE",
        purchase: {
          content: ButtonsArea.Top.content,
          step: ButtonsArea.Top.step,
        },
      }) : dispatch({
        type: "PURCHASE",
        purchase: {
          tryClick: payload.purchase.tryClick
            ? payload.purchase.tryClick + 1
            : 1,
        }
      })
    // console.log("func", ButtonsArea.Top.func);
    // console.log("checked", ButtonsArea.Top.checked);
    // console.log("errorRule",errorRule)

    ButtonsArea.Top.func && ButtonsArea.Top.checked && BuyPlan();
    setCheckError((prevState) => ({
      ...prevState,
      invoiceShowError: true,
      creditCardShowError: true,
    }));
    payload.purchase.step === "PixQrCode" && setOpenModalWaitPayment(true);
    setIsLoadingUserInfo(false);
  };

  const back = () => {
    if (ButtonsArea.Back.hasOwnProperty("funcCall") && ButtonsArea.Back.funcCall) {

      try{
        ButtonsArea.Back.funcCall(ButtonsArea.Back.content);
      }catch(e){
        console.log("Error occurred while calling Back button function:", e);
        //setIsLoadingUserInfo(false);
        //return
      }
    }
    if (instantPay && payload.purchase.step === "InvoiceData") {
      global.window.location.href = "/painel";
    }
    dispatch({
      type: "PURCHASE",
      purchase: {
        content: ButtonsArea.Back.content,
        step: ButtonsArea.Back.step,
      },
    });
  };

  const theme = createTheme({
    palette: {
      ochre: {
        main: "#662D91",
        light: "#662D91",
        dark: "#430d6c",
        contrastText: "#FFF",
      },
      ochreBack: {
        main: "#FFF",
        light: "#FFF",
        // dark: "#787676",
        contrastText: "#787676",
      },
    },
  });

  return payload && (
    <aside className={classes.AsideContent}>
      <div className={classes.Title}>
        <img src={cart} alt="" /> <div>{t("purchase.my_purchase")}</div>
      </div>
      <div className={classes.PlanContent}>
        <div data-testid="aside_planChoose_text" className={classes.PlanCall}>{t("purchase.chosen_plan")}</div>
        <CardBase classPrimary={classes.CardBase}>
          <Typography
            data-testid="aside_planName_text"
            className={classes.PlanCardTitle}
            gutterBottom
            variant="h10"
            component="div"
          >
            {payload.planInfo?.planName}
          </Typography>
          {payload.planInfo?.planDescription?.map((descPlan, index) => {
            return (
              <Typography data-testid={`aside_planDesc_text_${index}`} className={classes.PlanCardDesc} key={index}>
                {descPlan}
              </Typography>
            );
          })}
          {payload.purchase.step === "ProfPlan" && (
            <Typography className={classes.PlanCardDesc}>
              {t(
                "purchase.ten_users_available_to_register_and_control_their_activities"
              )}
            </Typography>
          )}
        </CardBase>
      </div>
      <div className={classes.ValueArea}>
        <div>{t("purchase.total")}</div>
        <div data-testid="aside_planValue_text">{`${payload.planInfo.value} ${Periodicity}`}</div>
      </div>
      {payload.purchase.step === "PixQrCode" && (
        <div className={classes.WarningUnlockPlatform}>
          <img src={triangleWarning} alt={t("purchase.attention_triangle")} />
          <div>
            {t(
              "purchase.after_completing_your_purchase_it_may_take_up_to_one_hour_to_access_your_subscription"
            )}
          </div>
        </div>
      )}
      <ThemeProvider theme={theme}>
        <div className={classes.ButtonsArea}>
          {ButtonsArea.Top.show && (
            <Button
              onClick={TopButton}
              variant="contained"
              color="ochre"
              disabled={isLoadingUserInfo || !ButtonsArea.Top.checked}
              data-testid="asideShopping_continue_btn"
            >
              {ButtonsArea.Top.name}
            </Button>
          )}
          {ButtonsArea.Back.show && (
            <Button
              data-testid="asideShopping_return_btn"
              onClick={back}
              disabled={isLoadingUserInfo}
              style={{ width: "100%", fontWeight: "bold", gap: "15px" }}
              variant="contained"
              color="ochreBack"
            >
              <img
                style={{ width: "16px" }}
                src={arrowLeft}
                alt={t("purchase.left_arrow")}
              />
              <div>{t("purchase.return")}</div>
            </Button>
          )}
        </div>
      </ThemeProvider>
    </aside>
  );
};
export default Aside;
